<template>
  <div class="app-intro">
    <Carousel
      :value="slides"
      :num-visible="1"
      :num-scroll="1"
      :circular="true"
      :autoplay-interval="8000"
      :show-indicators="false"
      class="intro-carousel"
    >
      <template #item="slotProps">
        <div class="slide">
          <h3 class="slide-title">
            {{ slotProps.data.title }}
          </h3>
          <img 
            v-if="slotProps.data.image"
            :src="slotProps.data.image" 
            class="slide-image" 
            alt="slide image"
          >
          <video
            v-if="slotProps.data.video"
            :src="slotProps.data.video"
            class="slide-video"
            autoplay
            muted
            loop 
          />
          <div v-if="slotProps.data.cycle">
            <LearningCycleCard />
          </div>
          <p
            v-for="(paragraph, idx) in (Array.isArray(slotProps.data.text) ? slotProps.data.text : [slotProps.data.text])"
            :key="idx"
            class="slide-text"
          >
            {{ paragraph }}
          </p>
        </div>
      </template>
    </Carousel>
  </div>
</template>

<script>
import Carousel from "primevue/carousel";
import LearningCycleCard from "./LearningCycleCard.vue";

export default {
  name: "AppIntroduction",
  components: { Carousel, LearningCycleCard },
  data() {
    return {
      slides: [
        {
          title: "Your One-Stop Language Learning Companion",
          cycle: true,
          text: [
                  "ImmersiveLang will help you minimize your time juggling between tools, so you can focus on memorizing, practicing and creating, making your language learning journey more efficient and enjoyable."
                ]
        },
        {
          title: "A Multitude of Tools to Supercharge Your Learning",
          image: `${process.env.BASE_URL}media/reader-v0.4.0.png`,
          text: [
                  "Stuck on a difficult word? Struggling to grasp complex materials?",
                  "ImmersiveLang lets you instantly define terms, extract key vocabulary, and generate custom summaries and Q&As so you can master any content with ease.",
                ]
        },
        {
          title: "Spaced Repetition Flashcards & Vocabulary Insights",
          video: `${process.env.BASE_URL}media/vocab.mp4`,
          text: [
            "Reinforce your learning with spaced repetition flashcards. ImmersiveLang automatically creates flashcards from the words you look up, helping you retain new vocabulary more effectively.",
            "Review your flashcards regularly and watch your language skills improve over time. Stay motivated by watching your vocabulary grow.",
          ]
        },
        {
          title: "Check Vocabulary Directly in the Web",
          video: `${process.env.BASE_URL}media/extension.mp4`,
          text: ["ImmersiveLang is designed to provide an immersive experience for language learners", 
            "Sports, Art, Science, History - whatever your interest, ImmersiveLang has got you covered.",
            "Browse your favourite content and use our chrome extension to look up words and phrases instantly. No more switching between tabs or apps - just highlight the text and get the definition right there."
          ]
        }
      ],
    };
  
  },
  
};
</script>

<style scoped>
.app-intro {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90%;
  box-sizing: border-box;
  width: 100%;
  overflow-y: auto;
}

@media (max-width: 599px) {
  .app-intro {
    padding: 0;
  }
}

.intro-carousel {
  width: 100%;
  max-width: 600px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
}

@media (max-width: 599px) {
  .intro-carousel {
    max-width: 100%;
    max-height: calc(100vh - 200px);
  }
}

.slide {
  text-align: center;
  padding: 8px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.slide-title {
  margin: 8px 0;
  font-size: clamp(1.2rem, 2.5vw, 1.6rem);
  color: #2f3c85;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  padding: 0 16px;
}

.slide-image {
  max-height: min(280px, 30vh);
  width: auto;
  border-radius: 6px;
  object-fit: contain;
  margin: 16px auto;
}

@media (max-width: 599px) {
  .slide-image {
    max-height: min(200px, 25vh);
    max-width: 100%;
  }
}

.slide-video {
  max-height: min(350px, 30vh);
  width: auto;
  border-radius: 6px;
  margin: 16px auto;
  object-fit: contain;
}

@media (max-width: 599px) {
  .slide-video {
    max-height: min(200px, 25vh);
    max-width: 100%;
  }
}

.slide-text {
  margin: 8px auto;
  font-size: clamp(0.875rem, 2vw, 1rem);
  color: #252323;
  text-align: center;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  max-width: 800px;
  line-height: 1.5;
}

</style>